module.exports = __webpack_public_path__ + "img/tree.5b72793e.png";